<template>
  <v-app>
    <user-bar></user-bar>
    <contactUs></contactUs>
    <rooter></rooter>
  </v-app>
</template>

<script>
import userBar from 'Components/UserBar';
import ContactUs from 'Components/ContactUs';
import Rooter from 'Components/Rooter';
import 'Public/css/global.css';
import 'Public/css/fonts.css';

export default {
  name: 'App',
  data() {
    return {
      loggedIn: false,
    };
  },
  components: {
    userBar,
    ContactUs,
    Rooter,
  },

  methods: {},
};
</script>

<style></style>
